import React from 'react';
import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';
import PropTypes from 'prop-types';
import Pagination from 'components/ui/pagination';

export default function TagTable({
  page,
  selectedTagIds,
  selectedTags,
  setSelectedTags,
  tags,
  toggleSelectTag,
  totalPages,
  onPageChange
}) {
  if (tags.length === 0) return <h4 className="mt-4 text-muted">No tags found</h4>;

  const tagIds = new Set(tags.map(t => t.id));

  const allChecked = () => tags.every(tag => selectedTagIds.has(tag.id));

  function selectAllToggle(e) {
    const selected = e.target.checked;

    if (selected) {
      const newTags = tags.filter(tag => !selectedTagIds.has(tag.id));
      setSelectedTags([...selectedTags, ...newTags]);
    } else {
      setSelectedTags(selectedTags.filter(selectedTag => !tagIds.has(selectedTag.id)));
    }
  }

  function renderTagTableHeaders() {
    return (
      <>
        <th>Tag Name</th>
        <th>Total Instances</th>
        <th>Properties</th>
        <th>Contacts</th>
        <th>Companies</th>
      </>
    );
  }

  return (
    <>
      <div className="table-container">
        <SelectableRecordTable
          columnHeaders={renderTagTableHeaders()}
          hasSelectAll
          hasSelectColumn
          responsive
          selectAllChecked={allChecked()}
          onSelectAllToggle={selectAllToggle}
        >
          {tags.map(tag => (
            <SelectableRow
              key={tag.id}
              selected={selectedTagIds.has(tag.id)}
              onChange={() => toggleSelectTag(tag)}
            >
              <td className="auto-size hidden-sm hidden-xs">{tag.name}</td>
              <td className="auto-size hidden-sm hidden-xs">{tag.recordCountByType.totalCount}</td>
              <td className="auto-size hidden-sm hidden-xs">{tag.recordCountByType.propertiesCount}</td>
              <td className="auto-size hidden-sm hidden-xs">{tag.recordCountByType.peopleCount}</td>
              <td className="auto-size hidden-sm hidden-xs">{tag.recordCountByType.companiesCount}</td>
            </SelectableRow>
          ))}
        </SelectableRecordTable>
      </div>
      <Pagination currentPage={page} totalPages={totalPages} onChange={onPageChange}/>
    </>
  );
}

export const tagProps = PropTypes.shape({
  name: PropTypes.string,
  recordCountByType: PropTypes.shape({
    companiesCount: PropTypes.number,
    peopleCount: PropTypes.number,
    propertiesCount: PropTypes.number,
    totalCount: PropTypes.number
  })
});

TagTable.propTypes = {
  page: PropTypes.number.isRequired,
  selectedTagIds: PropTypes.instanceOf(Set),
  selectedTags: PropTypes.arrayOf(tagProps),
  setSelectedTags: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(tagProps),
  toggleSelectTag: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};
